<template>
  <rhcn-card-v2 class="card" :title="$t('message.refuse.klarnaRebutDrawer.transaction.title')" collapsible>
    <template #body>
      <el-descriptions :label-style="{ width: '160px' }" style="background-color: transparent;" :column="1" :colon="false">
        <el-descriptions-item :label="$t('message.refuse.klarnaRebutDrawer.transaction.transactionId')">
          {{ txnInfo?.txnId }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('message.refuse.klarnaRebutDrawer.transaction.orderId')">
          {{ txnInfo?.merchantTxnId }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('message.refuse.klarnaRebutDrawer.transaction.time')">
          {{ txnInfo?.txnTime }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('message.refuse.klarnaRebutDrawer.transaction.ip')">
          {{ txnInfo?.ip }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('message.refuse.klarnaRebutDrawer.transaction.userAgent')">
          {{ txnInfo?.userAgent }}
        </el-descriptions-item>
      </el-descriptions>

      <div class="trans-table">
        <p class="trans-table-title">{{ $t('message.refuse.klarnaRebutDrawer.transaction.tableTitle') }}</p>

        <el-table :header-row-style="{ background: 'transparent', fontSize: '12px' }" :data="refundList" style="width: 100%;" >
          <el-table-column v-for="column in tableCondition" :key="column.key" :prop="column.key" :label="$t(column.titleBar.title)" label-class="small-label">
            <template slot-scope="scope">
              <span>{{ column.textFunc ? column.textFunc(scope.row) : scope.row[column.key] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>
  </rhcn-card-v2>
</template>

<script>
import RhcnCardV2 from '@/componentsV2/base-cmps/card/index.vue';
import GlobalData from '@/utils/global/index';
import {
  getEnantiomericValue, splicingAmountAndCurrency, initSelectedData,
} from '@/utils/tools/constant';
export default {
  components: {
    RhcnCardV2,
  },
  props: {
    txnInfo: {
      type: Object,
      default: () => {},
    },
    refundList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dictList: {},
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.settlement.refundAmount' },
          type: 'text',
          key: 'refundAmount',
          textFunc: (data) => splicingAmountAndCurrency(data.refundAmount && data.refundAmount.currency, data.refundAmount && data.refundAmount.amount),
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.refundDate' },
          type: 'text',
          key: 'refundTime',
        },
        {
          titleBar: { type: 'text', title: 'message.transaction.refundStatus' },
          type: 'text',
          key: 'status',
          textFunc: (data) => getEnantiomericValue(initSelectedData(this.dictList.TXN_STATUS, 'description', 'value', false), data.status),
        },
        {
          titleBar: { type: 'text', title: 'message.transaction.refundArn' },
          type: 'text',
          key: 'arn',
        },
      ],
    };
  },
  mounted() {
    this.getDict();
  },
  methods: {
    initSelectedData,
    async getDict() {
      this.dictList = await GlobalData.getDictList(['TXN_STATUS']);
    },
  },
};
</script>

<style lang="scss" scoped>
.trans-table {
  margin-top: 16px;
  padding-top: 24px;
  border-top: 1px solid #EDF1F7;
  .trans-table-title {
    font-family: Open Sans, Open Sans;
    font-weight: 400;
    font-size: 14px;
    color: #1A202C;
    line-height: 18px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-bottom: 16px;
  }
}

.small-label {
  font-family: Open Sans, Open Sans;
  font-weight: 600;
  font-size: 12px;
  color: #8D98AF;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
</style>
